 import PlaceIcon from '@mui/icons-material/Place';
import { CircularProgress, Grid, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { styles } from '../../style/style';
import { setOrderDetailData } from '../orderdetail/orderDetailSlice';
import EventHistory from './OrderDetailHistoryTable';
import OrderOption from './OrderDetailOptionTable';
import log from '../../common/components/Logger'



export default function OrderDetail() {

    const login = useSelector((state) => state.login.data.payload.login);

    if (!login) {
        window.location.href = '/home';
    }

    const dataListRedux = useSelector((state) => state.orderDetail.orderDetailData);
    const ApiList = useSelector((state) => state.apiList.apiList);
    const searchType = useSelector((state) => state.orderDetail.orderSearchType.payload);
    const dataSearch = useSelector((state) => state.orderDetail.orderDetailSearch.payload);
    const [dataListItem, setDataListItem] = useState([]);
    const [eventHistoryList, setEventHistoryList] = useState();
    const [orderOptionsList, setOrderOptionsList] = useState();
    const idToken = localStorage.getItem("idToken");
    const [loading, setLoading] = useState(true);
    const userDetails = useSelector((state) => state.user.data.payload);
    const dispatch = useDispatch();
    const [config, setConfig] = useState(
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'guid': `${ApiList.guid}`
            }
        })

    useEffect(() => {
        if (searchType === 'leftClick') {
            if (dataListRedux !== undefined) {
                setDataListItem(dataListRedux.payload);
                console.log("LEFT CLICK");
                console.log(dataListItem);
            }
        } else if (searchType === 'rightClick') {
            const url = ApiList.getOrderDetail;

            axios.post(url, dataSearch, config)
                .then(res => {
                    log.info(`fos_ui_log: OrderDetail(): ${res.data.statusMessage}`)
                    setDataListItem(res.data.orderDetail)
                    dispatch(setOrderDetailData(res.data.orderDetail));
                    setLoading(false)
                    console.log("RIGHT CLICK");
                    console.log(dataListItem);


                }).then(
                    setLoading(false)
                )
                .catch(err => console.log(err))
        }

    }, [dataListItem, searchType])

    useEffect(() => {
        log.info(`fos_ui_log: OrderDetail():getEventHistoryList Fetching event history list`)
        const url = ApiList.getEventHistoryList;
        const data = {
            orderData: {
                orderNumber: dataListRedux.payload.vehOrderNum,
                partnerType: userDetails.partnerType,
                fan: dataListRedux.payload.primaryFan,
                vin: dataListRedux.payload.vin,
                bac: dataListRedux.payload.chargeToBac
            }
        }

        axios.post(url, data, config)
            .then(res => {
                if (res.status == 200) {
                    setEventHistoryList(res.data.eventHistoryList);
                    log.info(`fos_ui_log: OrderDetail():getEventHistoryList Event history list: ${res.data.eventHistoryList}`)
                }
            })
            .catch((err) => {
                setEventHistoryList('ERROR')
                console.log(err);
                log.error(`fos_ui_log: OrderDetail():getEventHistoryList  ${err.message}`)
            });
    }, [])

    
    useEffect(() => {
        log.info(`fos_ui_log: OrderDetail():getOrderOptionsList order options list`)
        const url = ApiList.getOrderOptionsList;
        const data = {
            orderData: {
                orderNumber: dataListRedux.payload.vehOrderNum,
                partnerType: userDetails.partnerType,
                fan: dataListRedux.payload.primaryFan,
                vin: dataListRedux.payload.vin,
                bac: dataListRedux.payload.chargeToBac
            }
        }

        axios.post(url, data, config)
            .then(res => {
                if (res.status == 200) {
                    setOrderOptionsList(res.data.orderOptionsList);
                    log.info(`fos_ui_log: OrderDetail():getOrderOptionsList Order Option list: ${res.data.orderOptionsList}`)
                }
            })
            .catch((err) => {
                console.log(err);
                log.error(`fos_ui_log: OrderDetail():getOrderOptionsList  ${err.message}`)
            });
    }, [])


    return (
        <div>
            <Box sx={styles.masterMargin}>
                <Grid container>
                    <Typography id="orderDetailTitle" variant="h2" sx={styles.h2PageTitle}><><FormattedMessage id='orderdetailcomponents.orderNumber' defaultMessage='Order Number: ' /> {dataListItem.vehOrderNum}</></Typography>
                    <Grid container sx={styles.tablePadding}>
                        <Grid item xs={12}>
                            <Stack direction='row' spacing={3} sx={styles.stackMargin2percent}>
                                <Box sx={styles.orderDetailWidth33percent}>
                                    <Grid item xs={10} sx={styles.orderDetailBoxShadow}>
                                        <br />
                                        <Typography id="currentEventTitle" variant="h3" sx={styles.currentEventLabel}><FormattedMessage id='orderdetailcomponents.currentEvent' defaultMessage='Current Event' /></Typography>
                                        <br />
                                        <br />
                                        <br />


                                        <Typography id="eventCodeDescription" align="center" variant="h4" sx={styles.h4InformationGroupHeader}>
                                            <strong>

                                                {dataListItem.currentEventCode} - <FormattedMessage
                                                    id={`eventcode.${dataListItem.currentEventCode}`}
                                                    defaultMessage="Event Code Description Unavailable" />

                                            </strong>
                                        </Typography>


                                        <Typography id="eventDate" align="center" variant="body1" sx={styles.pBodyText}><FormattedMessage id='orderdetailcomponents.eventDate' defaultMessage='Event Date: ' /> {dataListItem.currentEventDate}</Typography>
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                    </Grid>
                                </Box>
                                <Box sx={styles.orderDetailWidth33percent}>
                                    <Grid item xs={12}>
                                        <Typography id="shipToInfoTitle" variant="h3" sx={styles.orderDetailLabels}><FormattedMessage id='orderdetailcomponents.shipToInformation' defaultMessage='Ship-To Information' /></Typography>
                                        <br />
                                        <Typography id="shippingCompanyName" variant="h4" sx={styles.h4InformationGroupHeader}><strong>
                                            {dataListItem.shippingCompanyName !== "COMPANY_NOT_AVAILABLE" ? (
                                                dataListItem.shippingCompanyName
                                            ) : (
                                                <FormattedMessage
                                                    id={dataListItem.shippingCompanyName.toString().toUpperCase().replace(/ /g, "_")}
                                                    defaultMessage='Company not available' />
                                            )}
                                        </strong>
                                        </Typography>
                                        <Typography id="shippingCompanyLocation" align="left" variant="body1" sx={styles.pBodyText}><PlaceIcon fontSize="medium" />
                                            {dataListItem.shippingCompanyLocation !== "LOCATION_NOT_AVAILABLE" ? (
                                                dataListItem.shippingCompanyLocation
                                            ) : (
                                                <FormattedMessage
                                                    id={dataListItem.shippingCompanyLocation.toString().toUpperCase().replace(/ /g, "_")}
                                                    defaultMessage='Location not available' />
                                            )}

                                        </Typography>
                                        <br />
                                        <Grid item xs={10}>
                                            <Stack direction='row' spacing={5}>
                                                <Box sx={styles.orderDetailWidth40percent}>
                                                    <Grid item xs={12}>
                                                        <Typography id="shipToBacHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.shipToBusinessAssociateCode' defaultMessage='Ship-To Bac' /></strong></Typography>
                                                        <Typography id="shiptoBacCode" variant="caption" sx={styles.shipToValues}>{dataListItem.shipToBac}</Typography>

                                                    </Grid>
                                                </Box>
                                                <Box sx={styles.orderDetailWidth40percent}>
                                                    <Grid item xs={12}>
                                                        <Typography id="shipToBfcHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.shipToBusinessFunctionCode' defaultMessage='Ship-To Bfc' /></strong></Typography>
                                                        <Typography id="shipToBfcCode"variant="caption" sx={styles.shipToValues}>{dataListItem.shipToBfc}</Typography>
                                                    </Grid>
                                                </Box>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={styles.orderDetailWidth33percent}>
                                    <Grid item xs={12}>
                                        <Typography id="chargeToInfoTitle" variant="h3" sx={styles.orderDetailLabels}><FormattedMessage id='orderdetailcomponents.chargeToInformation' defaultMessage='Charge-To Information' /></Typography>
                                        <br />

                                        <Typography id="chargeCompanyName" variant="h4" sx={styles.h4InformationGroupHeader}><strong>
                                            {dataListItem.dealerCompanyName !== "COMPANY_NOT_AVAILABLE" ? (
                                                dataListItem.dealerCompanyName
                                            ) : (
                                                <FormattedMessage
                                                    id={dataListItem.dealerCompanyName.toString().toUpperCase().replace(/ /g, "_")}
                                                    defaultMessage='Company not available' />
                                            )}
                                        </strong>
                                        </Typography>

                                        <Typography id="chargeCompanyLocation" align="left" variant="body1" sx={styles.pBodyText}><PlaceIcon fontSize="medium" />
                                            {dataListItem.dealerCompanyLocation !== "LOCATION_NOT_AVAILABLE" ? (
                                                dataListItem.dealerCompanyLocation
                                            ) : (
                                                <FormattedMessage
                                                    id={dataListItem.dealerCompanyLocation.toString().toUpperCase().replace(/ /g, "_")}
                                                    defaultMessage='Location not available' />
                                            )}
                                        </Typography>
                                        <br />
                                        <Grid item xs={10}>
                                            <Stack direction='row' spacing={6}>
                                                <Box sx={styles.orderDetailWidth40percent}>
                                                    <Grid item xs={12}>
                                                        <Typography id="chargeToBacHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.chargeToBusinessAssociateCode' defaultMessage='Charge-To Business Associate Code (BAC)' /></strong></Typography>
                                                        <Typography id="chargeToBacCode" variant="caption" sx={styles.shipToValues}>{dataListItem.chargeToBac}</Typography>
                                                    </Grid>
                                                </Box>
                                                <Box sx={styles.orderDetailWidth40percent}>
                                                    <Grid item xs={12}>
                                                        <Typography id="chargeToBfcHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.chargeToBusinessFunctionCode' defaultMessage='Charge-To Bfc' /></strong></Typography>
                                                        <Typography id="chargeToBfcCode" variant="caption" sx={styles.shipToValues}>{dataListItem.shipToBfc}</Typography>
                                                    </Grid>
                                                </Box>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Stack>
                        </Grid>
                        <Grid item xs={12}>
                            <Stack direction='row' spacing={2} sx={styles.stackMargin2percent}>
                                <Box sx={styles.orderDetailWidth40percent}>
                                    <Grid item xs={12} sx={styles.masterMargin}>
                                        <br />
                                        <Typography id="vehicleInfoHeader" variant="h4" sx={styles.vehicleInformationLabel}><FormattedMessage id='orderdetailcomponents.vehicleInformation' defaultMessage='Vehicle Information' /></Typography>
                                        <Grid item xs={10}>
                                            <Stack direction='row' spacing={10}>
                                                <Box sx={styles.orderDetailWidth40percent}>
                                                    <Grid item xs={12}>
                                                        <br />
                                                        <Typography id="modelHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.model' defaultMessage='Model' /></strong></Typography>
                                                        <Typography id="modelValue" variant="caption" sx={styles.shipToValues}>{dataListItem.modelNum}</Typography>
                                                        <br />
                                                        <br />
                                                        <Typography id="vinHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.vin' defaultMessage='VIN' /></strong></Typography>
                                                        <Typography id="vinValue" variant="caption" sx={styles.shipToValues}>{dataListItem.vin}</Typography>
                                                        <br />
                                                        <br />
                                                        <Typography id="divisionHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.division' defaultMessage='Division' /></strong></Typography>
                                                        <Typography id="divisionValue" variant="caption" sx={styles.shipToValues}>{dataListItem.division}</Typography>
                                                    </Grid>
                                                </Box>
                                                <Box sx={styles.orderDetailWidth40percent}>
                                                    <Grid item xs={12}>
                                                        <br />
                                                        <Typography id="modelYearHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.modelYear' defaultMessage='Model Year' /></strong></Typography>
                                                        <Typography id="modelYearValue" variant="caption" sx={styles.shipToValues}>{dataListItem.modelYear}</Typography>
                                                        <br />
                                                        <br />
                                                        <Typography id="allocGroupHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.allocationGroup' defaultMessage='Allocation Group' /></strong></Typography>
                                                        <Typography id="allocGroupValue" variant="caption" sx={styles.shipToValues}>{dataListItem.allocationGroup}</Typography>
                                                    </Grid>
                                                </Box>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Grid item xs={9} sx={styles.orderDetailBoxShadow}>
                                    <Typography id="orderDetailsHeader" variant="h4" sx={styles.orderDetailBoxLabel}><FormattedMessage id='orderdetailcomponents.orderDetails' defaultMessage='Order Details' /></Typography>
                                    <Grid item xs={12} sx={styles.orderDetailBoxMargin}>
                                        <Stack direction='row' spacing={10}>
                                            <Box sx={styles.orderDetailWidth50percent}>
                                                <Grid item xs={12}>
                                                    <Typography id="primaryFanHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.primaryFleetAccountNumber' defaultMessage='Primary Fleet Account Number (FAN)' /></strong></Typography>
                                                    <Typography id="primaryFanValue" variant="caption" sx={styles.shipToValues}>{dataListItem.primaryFan}</Typography>
                                                    <br />
                                                    <br />
                                                    <Typography id="requestTpwHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.requestedTargetProductionWeek' defaultMessage='Requested Target Production Week (TPW)' /></strong></Typography>
                                                    <Typography id="requestTpwValue" variant="caption" sx={styles.shipToValues}>{dataListItem.targetProductionWeek}</Typography>
                                                    <br />
                                                    <br />
                                                    <Typography id="orderReciptDateHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.orderReceiptDate' defaultMessage='Order Receipt Date' /></strong></Typography>
                                                    <Typography id="orderReciptDateValue" variant="caption" sx={styles.shipToValues}>{dataListItem.orderReceiptDate}</Typography>
                                                </Grid>
                                            </Box>
                                            <Box sx={styles.orderDetailWidth50percent}>
                                                <Grid item xs={12}>
                                                    <Typography id="endUserFanHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.endUserFleetAccountNumber' defaultMessage='End User Fleet Account Number (FAN)' /></strong></Typography>
                                                    <Typography id="endUserFanValue" variant="caption" sx={styles.shipToValues}>{dataListItem.endUserFan}</Typography>
                                                    <br />
                                                    <br />
                                                    <Typography id="actualTpwHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.actualTargetProductionWeek' defaultMessage='Actual Target Production Week (TPW)' /></strong></Typography>
                                                    <Typography id="actualTpwValue" variant="caption" sx={styles.shipToValues}>{dataListItem.actualProductionWeek}</Typography>
                                                    <br />
                                                    <br />
                                                    <Typography id="poNumberHeader" variant="body1" sx={styles.shipToLabel}><strong><FormattedMessage id='orderdetailcomponents.purchaseOrderNumber' defaultMessage='Purchase Order (PO) Number' /></strong></Typography>
                                                    <Typography id="poNumberValue" variant="caption" sx={styles.shipToValues}>{dataListItem.purchaseOrderNum}</Typography>
                                                    <br />
                                                    <br />
                                                    <br />
                                                </Grid>
                                            </Box>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Stack>
                        </Grid>
                    </Grid>

                </Grid>
                <Grid item sx={styles.eventHistoryTableMargin}>
                    <Stack direction='row' spacing={20}>
                        {eventHistoryList !== null && eventHistoryList !== undefined && eventHistoryList !== 'ERROR' ? (
                            <Box sx={styles.eventHistoryBoxSizing}>
                                <Grid item xs={6}>
                                    <Typography id="eventHistoryHeader" variant="h4" sx={styles.orderDetailLabels}><FormattedMessage id='orderdetailcomponents.eventHistory' defaultMessage='Event History' /></Typography>
                                    <br />
                                    <EventHistory eventHistoryList={eventHistoryList} />
                                </Grid>
                            </Box>
                         ) 
                         : eventHistoryList == 'ERROR' ? (
                             <Box sx={styles.orderDetailWidth50percent}>
                                 <Grid item xs={12} sx={styles.orderDetailBoxM3MB8}>
                                    <Typography id="eventHistoryHeader" variant="h4" sx={styles.orderDetailLabels}><FormattedMessage id='orderdetailcomponents.eventHistory' defaultMessage='Event History' /></Typography>
                                    <br />
                                     <Stack direction="row" spacing={2}>
                                         <Typography id="eventHistoryError" variant="h4" sx={styles.orderDetailLabels}>
                                             <FormattedMessage id='orderdetailcomponents.eventHistoryError' defaultMessage='Error' />
                                         </Typography>
                                     </Stack>
                                 </Grid>
                             </Box>
                         )
                         : (
                            <Box sx={styles.orderDetailWidth50percent}>
                                <Grid item xs={12} sx={styles.orderDetailBoxM3MB8}>
                                    <Stack direction="row" spacing={2}>
                                        <CircularProgress />
                                        <Typography id="eventHistoryLoader" variant="h4" sx={styles.orderDetailLabels}>
                                            <FormattedMessage id='orderdetailcomponents.eventHistory.loadingSpinner' defaultMessage='Loading Event History...' />
                                        </Typography>
                                    </Stack>
                                </Grid>
                            </Box>)}
                            {orderOptionsList !== null && orderOptionsList !== undefined ? (
                            <Box sx={styles.orderDetailWidth50percent}>
                                <Grid item xs={6}>
                                    <OrderOption orderOptionsList={orderOptionsList} />
                                </Grid>
                            </Box>
                        ) : (
                            <Box>
                                <Grid item xs={12} sx={styles.orderDetailBoxM3MB8}>
                                    <Stack direction="row" spacing={2}>
                                        <CircularProgress />
                                        <Typography variant="h4" sx={styles.orderDetailLabels}>
                                            <FormattedMessage id='orderdetailcomponents.orderOptions.loadingSpinner' defaultMessage='Loading Order Options...' />
                                        </Typography>
                                    </Stack>
                                </Grid>
                            </Box>)}
    
                    </Stack>
                </Grid>
            </Box>
        </div>

    )
}
